// BASE SET
const SET_BASE_MODEL = 'setBaseModel'
const SET_SIZE = 'setSize'
const SET_UPPER_MATERIAL = 'setUpperMaterial'
const SET_OPENING_PATTERN = 'setOpeningPattern'
const SET_VAMP_STRAP_TYPE = 'setVampStrapType'
const SET_TONGUE = 'setTongue'
const SET_OUT_SOLE = 'setOutSole'
const SET_LINE_TYPE = 'setLineType'
const SET_TOE_GUARD = 'setToeGuard'
const SET_TOE_GUARD_KIND = 'setToeGuardKind'

// COLOR SET
const SET_PARTS = 'setParts'
const SET_WHOLE_COLOR = 'setWhole'
const SET_MAIN_UNIT_COLOR = 'setMainUnit'
const SET_TOE_REINFORCEMENT_COLOR = 'setToeReinforcement'
const SET_VAMP_STRAP_REINFORCEMENT_COLOR = 'setVampStrapReinforcement'
const SET_HEAL_REINFORCEMENT_COLOR = 'setHealReinforcement'
const SET_SIDE_REINFORCEMENT_COLOR = 'setSideReinforcement'
const SET_OPENING_REINFORCEMENT_COLOR = 'setOpeningReinforcement'
const SET_OPENING_COLOR = 'setOpening'
const SET_HEAL_DECORATION_COLOR = 'setHealDecoration'
const SET_TONGUE_FRONT_COLOR = 'setTongueFront'
const SET_MAGIC_BELT_MATERIAL = 'setMagicBeltMaterial'
const SET_MAGIC_BELT_BASE = 'setMagicBeltBase'
const SET_TOE_GUARD_COLOR = 'setToeGuardColor'
const SET_LINE_COLOR = 'setLine'
const SET_LINE_COLOR_2 = 'setLine2'
const SET_VAMP_STRAP_COLOR = 'setVampStrap'
const SET_VAMP_STRAP_BELT_1 = 'setVampStrapBelt1'
const SET_VAMP_STRAP_BELT_2 = 'setVampStrapBelt2'
const SET_VAMP_STRAP_BELT_3 = 'setVampStrapBelt3'
const SET_STITCH_COLOR = 'setStitch'
const SET_TONGUE_LININGS_COLOR = 'setTongueLinings'
const SET_MIDDLE_CUT_OPENING_COLOR = 'setMiddleCutOpening'
const SET_ATOMS_LABE = 'setAtomsLabel'
const SET_SHOES_STATE = 'setShoesState'

// EMBROIDERY
const SET_EMBROIDERIES = 'setEmbroideries'
const ADD_EMBROIDERY = 'addEmbroideries'
const REMOVE_EMBROIDERY = 'RemoveEmbroideries'

const SET_PERSONAL = 'setPersonal'
const SET_FIGURE_PANEL_NUMBER = 'setFigurePanelNumber'

// これはカラーだけに関するconstantsなので、別ファイルにあるべき
export const SHOES_DISPATCHER = {
  setShoesState: SET_SHOES_STATE,
  upperMaterial: SET_UPPER_MATERIAL,
  size: SET_SIZE,
  openingPattern: SET_OPENING_PATTERN,
  vampStrapType: SET_VAMP_STRAP_TYPE,
  tongue: SET_TONGUE,
  outSole: SET_OUT_SOLE,
  lineType: SET_LINE_TYPE,
  toeGuard: SET_TOE_GUARD,
  toeGuardKind: SET_TOE_GUARD_KIND,
  // parts
  parts: SET_PARTS,
  whole: SET_WHOLE_COLOR,

  mainUnit: SET_MAIN_UNIT_COLOR,
  toeReinforcement: SET_TOE_REINFORCEMENT_COLOR,
  vampStrapReinforcement: SET_VAMP_STRAP_REINFORCEMENT_COLOR,
  healReinforcement: SET_HEAL_REINFORCEMENT_COLOR,
  sideReinforcement: SET_SIDE_REINFORCEMENT_COLOR,
  openingReinforcement: SET_OPENING_REINFORCEMENT_COLOR,
  opening: SET_OPENING_COLOR,
  healDecoration: SET_HEAL_DECORATION_COLOR,
  tongueFront: SET_TONGUE_FRONT_COLOR,
  magicBeltMaterial: SET_MAGIC_BELT_MATERIAL,
  magicBeltBase: SET_MAGIC_BELT_BASE,
  toeGuardColor: SET_TOE_GUARD_COLOR,
  // sub color
  line: SET_LINE_COLOR,
  line2: SET_LINE_COLOR_2,
  vampStrap: SET_VAMP_STRAP_COLOR,
  vampStrapBelt1: SET_VAMP_STRAP_BELT_1,
  vampStrapBelt2: SET_VAMP_STRAP_BELT_2,
  vampStrapBelt3: SET_VAMP_STRAP_BELT_3,
  stitch: SET_STITCH_COLOR,
  tongueLinings: SET_TONGUE_LININGS_COLOR,
  middleCutOpening: SET_MIDDLE_CUT_OPENING_COLOR,
  atomsLabel: SET_ATOMS_LABE
}
